/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { MapCommand } from '../map-command.class';
import { DigitizePointLauncherService } from './digitize-point-launcher.service';
import { DigitizePointService } from './digitize-point.service';
import { map, take } from 'rxjs/operators';
import { Subject } from 'rxjs';

export class DigitizePointCommand extends MapCommand {

    invoke() {
        const closed$ = new Subject<void>();
        closed$.pipe(
            take(1),
        ).subscribe(() => this.deactivate$.next());

        (<DigitizePointLauncherService>this.deps['digitizePointLauncherService']).enableDigitize(closed$);
    }

    protected onCommandInit() {
        super.onCommandInit();
        const digitizeService: DigitizePointService = this.deps['digitizeService'];
        this.shouldDisplay$ = digitizeService.potentiallyDigitizableLayers$.pipe(
            map(p => p.length > 0),
        );
        this.shouldDisable$ = digitizeService.digitizableLayers$.pipe(
            map(layers => layers.length === 0)
        );
    }
}
